import React from 'react';
import { tnPortableCheck, updateCartTNPorted, updateTn } from './../../action/buildProduct';
import Button from './../../components/button';
import Loader from './../../components/loader';
import  PhoneNumber  from './../../components/phoneNumber';
import { InHomeUtils } from './../../util/inhomeUtils';
import { connect } from 'react-redux';
import { ModalTitle, ModalBody } from '@vds/modals';
import { Input } from '@vds/inputs';
import { TitleLockup } from '@vds/type-lockups';
import { FiosReferralKeyboard } from '../fiosRetailTablet/Keyboard/FiosReferralKeyboard';

class winback extends React.PureComponent {
    constructor(props) {
        super(props);
        this.isReskin = this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
        this.state = {
            isKeyboardForCurrentPhone: false,
            phoneNumber: ""
        }
        this.keyboard = React.createRef();
    }
    checkWinBack = () => {
        if(InHomeUtils.isNotNull(this.props.hasOwnTn)){
            let hasOwnTn=`${this.props.hasOwnTn.ph1}${this.props.hasOwnTn.ph2}${this.props.hasOwnTn.ph3}`;
            if (hasOwnTn !== "" && hasOwnTn.length === 10){
                tnPortableCheck(hasOwnTn, this.props.dispatch, this.props.visitId,this.props.isDoFlow);
            }
        }
        
    }
    addTNToCart = () => {        
        updateCartTNPorted(this.props.visitId,this.props.isDoFlow,this.props.pyoacProducts, this.props.dispatch,`${this.props.hasOwnTn.ph1}${this.props.hasOwnTn.ph2}${this.props.hasOwnTn.ph3}`,this.props.product, false,"",this.props.buildProduct);        
    }
    handleKeyPress = (e) => {
        e.target.value = this.formatPhoneNo(e.target.value);
    };
    removeLastHyphen = (value) => {
        let n = value.lastIndexOf("-");
        return value.substring(0, n);
    }

    formatPhoneNo2 = (value) => {
        var val = value.replace(/[^0-9]/g, '');
        if (value != null && value.length > 0) {          

            var number = val.split('');
            var check = 2;
            val = "";
            for (var count = 0; count < number.length; count++) {
                if (count < 10) {
                    if (count === check) {
                        val = val + number[count] + "-";
                        check = 5;
                    }
                    else
                        val = val + number[count];
                }
            }
            // if (val.lastIndexOf('-') > 0 && val.lastIndexOf('-') === (val.length - 1))
            //     val = this.removeLastHyphen(val);
        }       
        return val;
    }
    formatPhoneNo = (value) => {
        let val = value.replace(/[^0-9]/g, '');
        if (value !== null && value.length > 0) {
            let number = val.split('');
            let check = 2;
            val = "";

            for (let count = 0; count < number.length; count++) {
                if (count === check) {
                    val = val + number[count] + "-";
                    check = 5;
                }
                else
                    val = val + number[count];
            }
            if (val.lastIndexOf('-') > 0 && val.lastIndexOf('-') === (val.length - 1))
                val = this.removeLastHyphen(val);
        }
        return val;
    }

    updatePhoneNumberState= (id, value, e) =>{
        id = id.toLocaleUpperCase();
        updateTn(id,value,this.props.dispatch); 
    }
    updatePhoneNumberStateRskn= (e) =>{
        if(e.target.value.length > 2){
        let PH1 = e.target.value.slice(0,3)
        updateTn('PH1',PH1,this.props.dispatch); 
        }
        if(e.target.value.length > 6){
        let PH2 = e.target.value.slice(4,7)
        updateTn('PH2',PH2,this.props.dispatch); 
        }
        if(e.target.value.length > 11){
        let PH3 = e.target.value.slice(8,12)
        updateTn('PH3',PH3,this.props.dispatch);         }
    }

    updatePhoneNumberStateRsknFiosReferral= (e) =>{
        if (e.hostedAttractLoop && e.target.value.length <= 2) {
            let PH1 = e.target.value.slice(0,2)
            updateTn('PH1',PH1,this.props.dispatch);
            updateTn('PH2',"",this.props.dispatch);
            updateTn('PH3',"",this.props.dispatch);
        }
        if(e.target.value.length > 2){
            let PH1 = e.target.value.slice(0,3)
            updateTn('PH1',PH1,this.props.dispatch);
            if (e.target.value.length <=6) {
                updateTn('PH2',e.target.value.slice(4),this.props.dispatch);
            }
        }
        if(e.target.value.length > 6){
            let PH2 = e.target.value.slice(4,7)
            updateTn('PH2',PH2,this.props.dispatch);
            if (e.target.value.length <= 11) {
                updateTn('PH3', e.target.value.slice(8),this.props.dispatch);
            }
        }
        if(e.target.value.length > 11){
            let PH3 = e.target.value.slice(8,12)
            updateTn('PH3',PH3,this.props.dispatch);
        }
    }

    onPhoneTextBoxClick = (e) => {
        const { name } = e.target;
        this.setState({ name }, () => {
            this.setState({ isKeyboardForCurrentPhone: true })
        })        
    }

    onPhoneKeyPress = (button) => {
        this.keyPressed = button;
        console.log(button);
    }

    onPhoneChange = (value) => {
        console.log(value);
        if (this.kePressed === "Clear") {
            this.keyboard.current.setInput("")
            this.setState({ phoneNumber: "" }, () => {
                this.updatePhoneNumberStateRsknFiosReferral({ hostedAttractLoop: true, target: { value: this.state.phoneNumber }});
            })
        } else if (this.keyPressed === "{backspace}" || value.length > 12) {
            this.keyboard.current.setInput(this.state.phoneNumber.substring(0, this.state.phoneNumber.length - 1));
            this.setState({ phoneNumber: this.state.phoneNumber.substring(0, this.state.phoneNumber.length - 1) }, () => {
                this.updatePhoneNumberStateRsknFiosReferral({ hostedAttractLoop: true, target: { value: this.state.phoneNumber }})
            })
            return;

        }  else {
            this.keyboard.current.setInput(this.formatPhoneNo2(value));
            this.setState({ phoneNumber: this.formatPhoneNo2(value) }, () => {
                this.updatePhoneNumberStateRsknFiosReferral({ hostedAttractLoop: true, target: { value: this.state.phoneNumber }});
            })
        }
       
    }    

    closeKeyboardForCurrentPhone = () => {
        this.setState({ isKeyboardForCurrentPhone: false });
    }
    render() {
        let disablebtn = true;
        const isFiosFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
        const hostedAttractLoop = sessionStorage.getItem("hostedAttractLoop") === "true";

        let tnInfo=`${this.props.hasOwnTn.ph1}${this.props.hasOwnTn.ph2}${this.props.hasOwnTn.ph3}`;
        if (tnInfo !== "" && tnInfo.length === 10){
            disablebtn = false;  
        }
 
        let headerMsg=!this.isReskin ? 'Enter your current phone number and we’ll let you know if you can keep the same number with your new service.' : `Please enter your phone number below. We'll see if it's available with your new service.`
        let oneTimeFeeMsg='Note:  a one time charge of $4.99 may apply.';
        let activeButton = <React.Fragment>            
            {!this.isReskin ? <><Button buttonText="Check my number" buttonStyle="button margin-auto auto right margin-left-tiny margin-top-tiny" onClick={this.checkWinBack} disableButton={disablebtn} />
            <Button buttonText="Cancel" buttonStyle="button margin-auto auto secondary right margin-top-tiny" onClick={this.props.closeModel} /></>:
            <><Button buttonText="Check my number" buttonStyle="button margin-auto auto margin-top-tiny" onClick={this.checkWinBack} disableButton={disablebtn} />
            <Button buttonText="Cancel" id="cancelNumber" buttonStyle="button auto secondary  margin-left-tiny margin-top-tiny"  onClick={this.props.closeModel} />
            </>}
        </React.Fragment>

        if (this.props.hasOwnTn.isPorted) {
            headerMsg = 'Your current phone number is available to add to your new service. A one time charge of $4.99 will apply.';
            oneTimeFeeMsg = 'To ensure a seamless transition to Verizon, we ask that you wait to contact your current provider until after your Verizon service is installed.';
            activeButton = <React.Fragment>
                <Button buttonText="Add to Cart" buttonStyle="button margin-auto auto right margin-left-tiny margin-top-tiny" onClick={this.addTNToCart} />
                <Button buttonText="Cancel" buttonStyle="button margin-auto auto secondary right margin-top-tiny" onClick={this.props.closeModel} />
            </React.Fragment>
        }

        if(!this.props.hasOwnTn.isPorted && this.props.hasOwnTn.portedTn!==''){
            headerMsg = !this.isReskin ? 'Your current phone number is not available to add to your new service' : `It looks like your current phone number isn't available. Try a different number or click cancel and we'll give you a new number.`;
            oneTimeFeeMsg = !this.isReskin ? 'You can try a different number and resubmit or click cancel and we will give you a new number' : '';
            activeButton = !this.isReskin ? <React.Fragment>
                <Button buttonText="Resubmit" buttonStyle="button margin-auto margin-left-tiny margin-top-tiny auto right" onClick={this.checkWinBack} />
                <Button buttonText="Cancel" buttonStyle="button margin-auto auto secondary right margin-top-tiny" onClick={this.props.closeModel} />
            </React.Fragment> : <React.Fragment>
                {/* <Button buttonText="Cancel" buttonStyle="button margin-auto auto secondary margin-left-tiny right margin-top-tiny" onClick={this.props.closeModel} />
                <Button buttonText="Resubmit" buttonStyle="button margin-auto margin-top-tiny auto right" onClick={this.checkWinBack} /> */}
                <Button buttonText="Resubmit" id="Resubmit" buttonStyle="button auto  margin-top-tiny" onClick={this.checkWinBack}/>
                <Button buttonText="Cancel" id="Resubmitcancel" buttonStyle="button secondary margin-auto margin-left-tiny auto margin-top-tiny" onClick={this.props.closeModel} />
            </React.Fragment>
        }




        return (
            <React.Fragment>
                {/* <div className="m_modal-width vzrf active" data-modal="winBackModal" data-modal-traditional-mobile="" role="dialog" aria-hidden="false" tabIndex="0" style={{ maxHeight: '844.2px', top: '50%' }}>                     */}
                <Loader />
                {!this.isReskin && <ModalTitle>
                        Bring your own number
                    </ModalTitle>}
                    {this.isReskin && <TitleLockup
                        data={{
                        eyebrow: {
                        size: 'titleMedium',
                        children: '',
                        },
                        title: {
                        bold: false,
                        size: 'titleLarge',
                        children: !this.props.hasOwnTn.isPorted && this.props.hasOwnTn.portedTn!=='' ? `We're sorry.` : 'Check your current number.',
                        },
                        }}
                        />
                        }
                    <ModalBody>
                            <div id="WBHeaderMsg">{headerMsg}</div>
                        {/* <div id="WBHeaderMsg">{!this.isReskin ? headerMsg : `Please enter your phone number below. We'll see if it's available with your new service.`}</div> */}
                        <br />
                        <div className="row margin-left-zero">
                            <div className= {!this.isReskin ? "column text-normal tiny-12 medium-6 padding-vert-zero" : "column text-normal tiny-12 medium-12 padding-vert-zero"}>
                    {!this.isReskin && <PhoneNumber    label="Phone number"
                                    valuePh1={this.props.hasOwnTn.ph1} 
                                    valuePh2={this.props.hasOwnTn.ph2}
                                    valuePh3={this.props.hasOwnTn.ph3} 
                                    hideStar = {true}
                                    updatePhoneNumberState={(id, value)=>this.updatePhoneNumberState(id, value)}/>}
                                   {this.isReskin && !hostedAttractLoop && <Input
                                    name="phoneNumber" 
                                    type="tel" 
                                    label="Phone number"
                                    onChange={(e)=>{this.updatePhoneNumberStateRskn(e)}}
                                    readOnly={false}
                                    required={true}
                                    disabled={false}
                                    error={!this.props.hasOwnTn.isPorted && this.props.hasOwnTn.portedTn!==''}
                                    style={{width:'100%'}}
                                    errorText=''
                                    defaultValue={''}
                                />}
                                {this.isReskin && hostedAttractLoop && isFiosFlag && <Input
                                    name="phoneNumber" 
                                    type="text" 
                                    label="Phone number"
                                    onClick={(e) => this.onPhoneTextBoxClick(e)}
                                    readOnly={false}
                                    required={true}
                                    disabled={false}
                                    error={!this.props.hasOwnTn.isPorted && this.props.hasOwnTn.portedTn!==''}
                                    style={{width:'100%'}}
                                    errorText=''
                                    value={this.state.phoneNumber}
                                    defaultValue={''}
                                    maxLength={12}
                                />}
                                <FiosReferralKeyboard
                                    showKeyboard={this.state.isKeyboardForCurrentPhone}
                                    closeKeyboard={this.closeKeyboardForCurrentPhone}
                                    onKeyPress={this.onPhoneKeyPress}
                                    onChange={this.onPhoneChange}                                    
                                    theme={"numericLocker"}
                                    inputName={this.state.name}
                                    keyboardContainerClass={"keyboard-container-for-winback-phone"}
                                    keyboard={this.keyboard}

                                 />
                            </div>
                        </div>
                        <div className="row">
                            <div className="columns" id="WBOneTimeFeeMsg">{!this.isReskin ? oneTimeFeeMsg : <span style={{fontFamily: 'Verizon-NHG-eTX',fontWeight: 400,fontSize: '12px',lineHeight: '16px',color: '#6F7171'}}>{!this.props.hasOwnTn.isPorted && this.props.hasOwnTn.portedTn!=='' ? '' : 'A one-time charge of $4.99 may apply.'}</span>}</div>
                        </div>
                        <br />
                    </ModalBody>
                    <div className="modal_footer" data-modal-footer="">
                        {activeButton}
                    </div>
                {/* </div> */}
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        buildProductState: state.buildProduct,
    }
}
export default connect(
    mapStateToProps
)(winback);

